module.exports = __webpack_public_path__ + "static/media/blockchain.db4dc095.jpg";